module.exports = __webpack_public_path__ + "img/message_open.7319e334.svg";